var _path, _path2, _rect, _path3, _path4, _rect2, _rect3, _rect4, _rect5, _rect6, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBread = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30766 4.84613H34.9229C35.3053 4.84613 35.6152 4.53618 35.6152 4.15383V0.692305C35.6152 0.309956 35.3053 0 34.9229 0H1.6923C1.30996 0 1 0.309956 1 0.692305V35.3076C1 35.6899 1.30996 35.9999 1.6923 35.9999H9.30766V4.84613ZM7.92305 34.6152V3.46152H34.2306V1.38461H2.38461V34.6152H7.92305Z",
    fill: "#828296"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8468 4.1543H31.4622V34.6157H7.92383V36.0003H32.1545C32.5368 36.0003 32.8468 35.6904 32.8468 35.308V4.1543Z",
    fill: "#828296"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.6914,
    y: 0.691406,
    width: 1.38461,
    height: 3.46152,
    fill: "#828296"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1541 9.6932H26.6156V35.3085H28.0002V9.0009C28.0002 8.61855 27.6903 8.30859 27.3079 8.30859H13.4618C13.0795 8.30859 12.7695 8.61855 12.7695 9.0009V35.3085H14.1541V9.6932Z",
    fill: "#828296"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7691 13.8475H18.9998V29.0782H21.7691V13.8475ZM18.3075 12.4629C17.9252 12.4629 17.6152 12.7728 17.6152 13.1552V29.7705C17.6152 30.1529 17.9252 30.4628 18.3075 30.4628H22.4614C22.8437 30.4628 23.1537 30.1529 23.1537 29.7705V13.1552C23.1537 12.7728 22.8437 12.4629 22.4614 12.4629H18.3075Z",
    fill: "#828296"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3086,
    y: 15.2305,
    width: 4.15383,
    height: 1.38461,
    fill: "#828296"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3086,
    y: 18,
    width: 4.15383,
    height: 1.38461,
    fill: "#828296"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3086,
    y: 20.7695,
    width: 4.15383,
    height: 1.38461,
    fill: "#828296"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3086,
    y: 23.5371,
    width: 4.15383,
    height: 1.38461,
    fill: "#828296"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 18.3086,
    y: 26.3086,
    width: 4.15383,
    height: 1.38461,
    fill: "#828296"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5398 18C15.9222 18 16.2321 18.31 16.2321 18.6923V22.1538C16.2321 23.3009 15.3022 24.2307 14.1552 24.2307H13.4629V22.8461H14.1552C14.5375 22.8461 14.8475 22.5362 14.8475 22.1538V18.6923C14.8475 18.31 15.1575 18 15.5398 18Z",
    fill: "#828296"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBread);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bread.4e56b08bb99b2523ce7bbb3a91477326.svg";